module.exports = __webpack_public_path__ + "img/download-pdf-icon.ffde5767.png";